module.exports = __webpack_public_path__ + "static/media/infinity.885cad80.svg";